module.exports = __webpack_public_path__ + "static/media/Karbonneutral-klimapartner.859dceb5.png";